/*
 * Ankur Mursalin
 *
 * https://encryptioner.github.io/
 *
 * Created on Thu Aug 04 2022
 */

import {
  defineStore,
} from 'pinia';
import {
  clientBaseUrl,
  identifyDeviceType,
  viewportBreakpoint,
  CONSTANTS,
} from '@/helpers';
import {
  useAuthStore,
} from '@/store/auth';
import {
  Navigation,
} from '@/type';

const navigations: Navigation[] = [
  {
    _id: '0',
    userOnly: true,
    order: 0,
    name: 'Dashboard',
    url: `${clientBaseUrl}/dashboard`,
    children: [],
  },
  {
    _id: '1',
    userOnly: true,
    order: 1,
    name: 'Portfolio',
    url: `${clientBaseUrl}/portfolios`,
    children: [],
  },
];

// eslint-disable-next-line import/prefer-default-export
export const useAppStore = defineStore('app', {
  state: () => ({
    device: {
      isMobile: false,
      // iPad pro will not be identified as mobile device,
      // but it is a touch device
      isTouchDevice: false,
      isSafari: false,
      isChrome: false,
      isFirefox: false,
      isMac: false,
      isWindows: false,
      isLinux: false,
      isIPad: false,
      isIPhone: false,
      isAndroidTablet: false,
      isAndroid: false,
      isFlutterWebview: false,
      isAndroidWebview: false,
    },
    breakpoint: '',
    isBootstrapped: false,
    prevRoutePath: '',
    navigations,
    sidebars: {
      pushNotificationHistory: {
        show: false,
      },
    },
  }),
  getters: {
    user: () => useAuthStore().user,
    availableNavigations(): Navigation[] {
      return this.navigations
        .filter((nv) => (this.user ? true : !nv.userOnly))
        .map((nv) => {
          const children = nv.children.filter((child) => (this.user ? true : !child.userOnly));
          return {
            ...nv,
            children,
          };
        })
        .sort((nv) => nv.order);
    },
    homeRoute(): string {
      if (!this.user) {
        return CONSTANTS.ROUTES.GUEST_HOME;
      }
      if (this.user.role === 'admin') {
        return CONSTANTS.ROUTES.ADMIN_HOME;
      }
      return CONSTANTS.ROUTES.MEMBER_HOME;
    },
  },
  actions: {
    async init(prevRoutePath: string) {
      this.prevRoutePath = prevRoutePath;
      if (this.isBootstrapped) {
        return;
      }

      await useAuthStore().localLogin();

      const device = identifyDeviceType();
      this.breakpoint = viewportBreakpoint();
      this.device = device;
      this.isBootstrapped = true;
    },

  },
  persist: {
    storage: window.sessionStorage,
  },
});
